import React from 'react';
import ReactDOM from 'react-dom';
import { handleClientCacheOnPageLoad } from './utils/clientCacheReload';
import App from './App';

handleClientCacheOnPageLoad();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);